module.exports = __webpack_public_path__ + "static/media/abc-school.53609db0.png";